import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			header: {
				background: theme.palette.primary.main,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				padding: 16
			},
			btnBack: {
				marginRight: 10,
				cursor: "pointer",
				"&:active": {
					opacity: 0.7
				}
			},
			rootBody: {
				overflowY: "hidden"
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 500
			},
			add: {
				textAlign: "center",
				fontSize: 14,
				fontWeight: 500,
				marginBottom: 20,
				color: theme.palette.primary.contrastText
			}
		}),
	{
		name: "FindProductPage",
		index: 1
	}
);

export default useStyles;
